<template>
  <span class="ai-badge d-inline-flex align-center ga-1">
    <v-icon
      size="12"
      color="primary"
    >
      mdi-auto-fix
    </v-icon>
    <span class="text-caption text-primary font-weight-medium">{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  label: string
}>()
</script>

<style scoped>
.ai-badge {
  background: rgba(var(--v-theme-primary), 0.08);
  border-radius: 12px;
  padding: 2px 8px;
  white-space: nowrap;
}
</style>
